import React, { useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import './Loader.css';


export const Loader = () => {
  useEffect(() => {
    scroll.scrollToBottom();
  });

  return (
    <div className="contain text-center result show-results">
      <div className="loadingio-spinner-rolling-fkywl1525x8">
        <div className="ldio-h0kanbowce4">
          <div />
        </div>
      </div>
    </div>
  );
};
